import React from 'react';
import { Route } from 'react-router-dom';
import { ContactMain } from '../ui/contact/ContactMain';
import { ContactDetails } from '../ui/contact/ContactDetails';

export const contactRoutes = [
    <Route path="/contact" element={<ContactMain />} key="contact" />,
    <Route path="/contact/:id" element={<ContactDetails />} key="contactDetails" />,
];
